/* Metadata only: native Judge.me rendering, colors and events stay app-owned. */
(() => {
  if (customElements.get('dio-review-accessibility')) return;
  customElements.define('dio-review-accessibility', class extends HTMLElement {
    connectedCallback() {
      this.names ||= new WeakMap();
      const synchronize = () => {
        if (!this.isConnected) return;
        this.querySelectorAll('.jm-histogram-row').forEach(row => {
          const rating = row.querySelector('.jm-histogram-row__rating')?.textContent.trim();
          const count = row.querySelector('.jm-histogram-row__frequency')?.textContent.trim();
          const current = row.getAttribute('aria-label');
          if (!rating || !count || !current) return;
          const previous = this.names.get(row);
          const native = previous && current === previous.last ? previous.native : current;
          const percentage = native.match(/\d+(?:\.\d+)?%/)?.[0];
          const next = rating + ' (stars), ' + count + ' reviews' + (percentage ? ' (' + percentage + ')' : '');
          this.names.set(row, {native, last:next});
          if (current !== next) row.setAttribute('aria-label', next);
        });
        this.querySelectorAll('.jm-histogram-row .jm-star-rating').forEach(stars => {
          // The containing filter already announces its correct rating and count.
          if (stars.getAttribute('aria-hidden') !== 'true') stars.setAttribute('aria-hidden', 'true');
        });
        this.querySelectorAll('a.jm-average-rating-display').forEach(link => {
          const labels = [...link.querySelectorAll('.jm-text')];
          // Flex gaps separate these values visually; retain that separation in text too.
          labels.slice(1).forEach(node => {
            const before = node.previousSibling;
            if (!before || before.nodeType !== Node.TEXT_NODE || !/\s/.test(before.textContent)) {
              node.before(document.createTextNode(' '));
            }
          });
          const text = [...link.querySelectorAll('.jm-text')].map(node => node.textContent.trim()).filter(Boolean).join(' ');
          const current = link.getAttribute('aria-label');
          if (!text || !current) return;
          const previous = this.names.get(link);
          const native = previous && current === previous.last ? previous.native : current;
          const next = native.includes(text) ? native : text + ' — ' + native;
          this.names.set(link, {native, last:next});
          if (current !== next) link.setAttribute('aria-label', next);
        });
      };
      let queued = false;
      this.observer = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; synchronize(); });
      });
      this.observer.observe(this, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['aria-label']});
      synchronize();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
